require('./bootstrap');

import 'summernote/dist/summernote-bs4';
import 'summernote/dist/summernote-bs4.css';

import Randomizer from './lib/Randomizer';
import ObjectUtil from "./lib/ObjectUtil";

window.Randomizer = new Randomizer(window.crypto.getRandomValues.bind(window.crypto));
window.ObjectUtil = ObjectUtil;

window.Vue = require('vue');

// custom translation helper.
// we rely on window.i18n being set in the blade template
function trans(string) {
    var t = ObjectUtil.get(window.i18n, string);
    if (t == null) return string;
    return t;
}
window.trans = trans;

Vue.prototype.trans = trans;
// make route helper from Ziggy accessible from Vue (window.route is set in the blade template)
Vue.prototype.route = window.route;
Vue.component('users', require('./components/Users.vue'));
Vue.component('companies', require('./components/Companies.vue'));
Vue.component('pages', require('./components/Pages.vue'));
Vue.component('mailtemplates', require('./components/Mailtemplates.vue'));
Vue.component('projects', require('./components/Projects'));
Vue.component('projectfilemanager', require('./components/Projectfilemanager.vue'));
Vue.component('player', require('./components/Player.vue'));
Vue.component('projectimport', require('./components/ProjectImport.vue'));
Vue.component('itemlist', require('./components/ItemList.vue'));
Vue.component('server-side-data-table', require('./components/ServerSideDataTable.vue'));

var app = new Vue({
    el: '#app'
});

$('.axios-form').on('submit', function (e) {
    e.preventDefault();

    var form = $(this);
    $('.has-error').removeClass('has-error');
    $('.help-block').css('display', 'none');
    $('.is-invalid').removeClass('is-invalid');

    axios.post(form.attr('action'), form.serialize()).then(function (response) {
        swal({
            title: form.data('successheader'),
            html: form.data('successtext'),
            type: 'success',
            timer: 1000,
            showConfirmButton: false
        }).then(function (result) {
            if (form.data("success-redirecturl")) {
                window.location.href = form.data("success-redirecturl");
            }
        });
    }).catch(function (error) {
        $.each(error.response.data.errors, function (key, value) {
            var $keyEl = $('#' + key);
            $keyEl.closest('.form-group').addClass('has-error');
            $keyEl.addClass('is-invalid');
            $('#' + key + '-advice').html(value).css('display', 'block');
        });

        swal({
            title: form.data('errorheader'),
            html: form.data('errortext'),
            type: 'error'
        });
    });

    return false;
});

$('body').on('click', '.confirm-delete', function (e) {
    e.preventDefault();
    var _this = $(this);

    swal({
        title: window.i18n.messages.confirm_header,
        text: window.i18n.messages.confirm_delete,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: window.i18n.messages.proceed,
        cancelButtonText: window.i18n.messages.cancel
    }).then(function (result) {
        if (result.value) {
            var method = 'get';
            if (_this.attr('data-method')) {
                method = _this.attr('data-method');
            }

            axios.request({
                url: _this.attr('href'),
                method: method
            }).then(function (response) {
                swal({
                    title: window.i18n.messages.success,
                    html: window.i18n.messages.delete_success,
                    type: 'success',
                    timer: 1000,
                    showConfirmButton: false
                }).then(function () {
                    if (_this.hasClass('no-reload')) {
                        return;
                    }
                    location.reload();
                });
            }).catch(function (error) {
                swal({
                    title: window.i18n.messages.error,
                    html: window.i18n.messages.delete_error,
                    type: 'error'
                });
            });
        }
    });
});

(function ($) {

    $.fn.shuffle = function () {
        var input = this;

        for (var i = input.length - 1; i >= 0; i--) {

            var randomIndex = Math.floor(Math.random() * (i + 1));
            var itemAtIndex = input[randomIndex];

            input[randomIndex] = input[i];
            input[i] = itemAtIndex;
        }
        return input;
    };
})(jQuery);

$('.summernote').summernote({
    height: 400
});

$('.select2').select2();

$('.tplayer-form').on('submit', function (e) {
    e.preventDefault();

    var form = $(this);
    $('.has-error').removeClass('has-error');
    $('.help-block').hide();

    axios.post(form.attr('action'), form.serialize()).then(function (response) {
        window.location.href = form.data("playerurl");
    }).catch(function (error) {
        swal({
            title: form.data('errorheader'),
            html: form.data('errortext'),
            type: 'error'
        });
    });

    return false;
});


//////////////////
// WEBPACK FOOTER
// ./resources/js/app.js
// module id = 21
// module chunks = 0